import React, { useCallback, useEffect } from 'react';

import { BottomCta } from '../components/BottomCta';
import * as styles from '../components/BottomCta/HomeBackground.module.css';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import { ClinicMarquee } from '../components/home/ClinicMarquee';
import { Hero } from '../components/home/Hero';
import { PlatformOverview } from '../components/home/PlatformOverview';
import { ResearchAndPub } from '../components/home/ResearchAndPub';
import { Testimonials } from '../components/home/Testimonials';
import { WhoIsItFor } from '../components/home/WhoIsItFor';
import Header from '../components/navbar/Header';
import MobileNav from '../components/navbar/MobileNav';
import { useMixpanel } from '../functions/Mixpanel';
import '../styles/web.css';

const IndexPage = () => {
  const { mixpanel } = useMixpanel();

  useEffect(() => {
    mixpanel.track('View Page', { 'Page Name': 'Web Overview' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const trackPlatform = useCallback(
    (value: 'Hero' | 'How it Works') => {
      mixpanel.track('View Platform', {
        'Page Name': 'Web Overview',
        Section: value,
      });
    },
    [mixpanel],
  );

  return (
    <div>
      <Header
        pageName="Overview Page"
        pageCategory={undefined}
        link={undefined}
      />
      <MobileNav
        buttonTitle={undefined}
        link={undefined}
        openInNewTab={undefined}
      />
      <Seo
        title="IVF powered by artificial intelligence | Alife "
        description="Alife is building technology for both clinics and patients to improve IVF outcomes."
        siteUrl="https://www.alifehealth.com/"
        keywords={undefined}
        image={undefined}
      />
      <div className="tw-flex tw-flex-col tw-items-center">
        <Hero onClick={() => trackPlatform('Hero')} />
        <ClinicMarquee />
        <PlatformOverview onClick={() => trackPlatform('How it Works')} />
        <WhoIsItFor />
        <ResearchAndPub />
        <Testimonials />
        <BottomCta
          bgClassName={styles.background}
          title="Ready to use data to your advantage?"
          subtitle="Connect with one of our AI experts to learn how you can optimize your clinic with Alife."
          ctaText="Get in touch"
          ctaLink="/request-a-demo"
        />
      </div>
      <Footer pageName="Web Overview" />
    </div>
  );
};

export default IndexPage;
